export default "__VITE_ASSET__CHgk1KmE__"